import { makeStyles } from "@material-ui/core/styles";
import { DownloadOutlined } from "@mui/icons-material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { LoadingButton } from "@mui/lab";
import React, { useEffect, useState } from "react";
import { TYPE_NOTIFICATION } from "../../components/reusable/NotificationBull";
import Spacer from "../../components/Spacer";
import useToast from "../../hooks/useToast";
import BanqueDeCvService from "../../services/BanqueCvService";
import LoadingSimpleBackdrop from "../tools/LoadingSimpleBackdrop";

import { Grid, Tooltip, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { format, fromUnixTime } from "date-fns";
import { fr } from "date-fns/locale";
import {
  exportMultipleSheetsToExcelJS,
  exportToExcelJS,
} from "../../helpers/ExcelJsHelper";

export const INTERNAL_FILE_STORAGE_PATH = process.env.REACT_APP_API_URL.replace(
  "api",
  "uploads",
);
//export const INTERNAL_FILE_STORAGE_PATH = "pgi.fid.mg/pgibackend/uploads";
export const INTERNAL_CV_STORAGE_PATH = INTERNAL_FILE_STORAGE_PATH + "/cv/";
export const INTERNAL_LM_STORAGE_PATH = INTERNAL_FILE_STORAGE_PATH + "/lm/";
export const INTERNAL_NIF_STORAGE_PATH = INTERNAL_FILE_STORAGE_PATH + "/nif/";
export const INTERNAL_PHOTO_STORAGE_PATH =
  INTERNAL_FILE_STORAGE_PATH + "/photo/";
export const INTERNAL_STAT_STORAGE_PATH = INTERNAL_FILE_STORAGE_PATH + "/stat/";
export const INTERNAL_DIPLOME_STORAGE_PATH =
  INTERNAL_FILE_STORAGE_PATH + "/diplome/";
export const INTERNAL_ATTESTATION_STORAGE_PATH =
  INTERNAL_FILE_STORAGE_PATH + "/attestation/";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function CvList(props) {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [tableColumns, setTableColumn] = useState([]);
  const [load, setLoad] = useState([]);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadExport, setLoadExport] = useState(false);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] =
    React.useState(false);
  const { Toast, showToast } = useToast();

  const classes = useStyles();
  const filter = props.filter;

  useEffect(() => {
    refreshTable();
  }, [filter.refresh]);

  useEffect(() => {
    ajusterColonne(
      handleSwitchCVinternExtern(
        window.location.pathname.includes("cv_intern"),
      ),
    );
  }, [window.location.pathname.includes("cv_intern")]);

  const ajusterColonne = (columns) => {
    let new_col = columns.slice();
    //spontanné
    if (filter?.objet_candidature?.id_type === "15") {
      setTableColumn(
        new_col.filter((item) => {
          return !["type_stage"].includes(item.field);
        }),
      );
      // stagiaire
    } else if (filter?.objet_candidature?.id_type !== "18") {
      setTableColumn(
        new_col.filter((item) => {
          return !["type_stage", "disponibilite"].includes(item.field);
        }),
      );
    } else {
      setTableColumn(new_col);
    }
  };

  useEffect(() => {
    if (filter.mot_cle || rows) handleFilter(filter.mot_cle);
  }, [filter.mot_cle, rows]);

  useEffect(() => {
    if (props.exp_export > 0) {
      handleRHCandidatToExcel(props.exp_export);
    }
  }, [props.exp_export]);
  useEffect(() => {
    if (props.excel_export > 0) {
      exportExperienceToExcel(props.excel_export);
    }
  }, [props.excel_export]);

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(rows);
      return;
    }

    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");

    setFilteredRows(
      rows.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot),
          ),
        ),
      ),
    );
  };

  const refreshTable = () => {
    if (filter.refresh > 0) {
      setOpenLoadingSimpleBackdrop(true);
      BanqueDeCvService.list({
        ...filter,
        isCVIntern: window.location.pathname.includes("cv_intern")
          ? "true"
          : "false",
      }).then((result) => {
        if (result && result.data) {
          setRows(result.data.map((row) => ({ ...row, id: row.ref })));
          setOpenLoadingSimpleBackdrop(false);
        } else {
          setOpenLoadingSimpleBackdrop(false);
        }
      });
    }
  };

  const handleAddIdToLoad = (id) => {
    let load_copy = load.slice();
    if (!Array.isArray(load)) {
      load_copy = [];
    }
    load_copy.push(id);
    setLoad(load_copy);
  };

  const handleRemoveIdToLoad = (id) => {
    let load_copy = load.slice();
    if (!Array.isArray(load)) {
      load_copy = [];
    }
    load_copy.splice(load_copy.indexOf(id), 1);
    setLoad(load_copy);
  };

  const handleDownloadZip = (row) => {
    handleAddIdToLoad(row.us_id);
    showToast(TYPE_NOTIFICATION.INFO, "Chargement des données à compresser...");
    BanqueDeCvService.downloadUploadedFiles(row)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Document de " + row.full_name + ".zip");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        showToast(TYPE_NOTIFICATION.ERROR, "Aucun fichier à télécharger");
      })
      .finally(() => {
        handleRemoveIdToLoad(row.us_id);
      });
  };

  const handleShowSelectedCV = (rw) => (ev) => {
    handleAddIdToLoad(rw.us_id);
    showToast(
      TYPE_NOTIFICATION.INFO,
      "Vous allez être redirigé vers le CV dans un instant ...",
    );
    try {
      if (filter.isCVIntern) {
        BanqueDeCvService.showCvByUserId(rw.us_id)
          .then((result) => {
            if (result.data) {
              window.open(INTERNAL_CV_STORAGE_PATH + result.data, "_blank");
            } else {
              showToast(
                TYPE_NOTIFICATION.ERROR,
                rw.full_name + " ne dispose pas de CV dans le systeme",
              );
            }
          })
          .finally(() => {
            handleRemoveIdToLoad(rw.us_id);
          });
      } else {
        BanqueDeCvService.showCvByUserIdexterne(rw.us_id)
          .then((result) => {
            if (result.data) {
              window.open(INTERNAL_CV_STORAGE_PATH + result.data, "_blank");
            } else {
              showToast(
                TYPE_NOTIFICATION.ERROR,
                rw.full_name + " ne dispose pas de CV dans le systeme",
              );
            }
          })
          .finally(() => {
            handleRemoveIdToLoad(rw.us_id);
          });
      }
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  const handleRHCandidatToExcel = (stat) => {
    // setLoadExport(true);
    setOpenLoadingSimpleBackdrop(true);
    if (stat > 0) {
      let cols = tableColumns.slice();
      if (!filter.isCVIntern) {
        cols.unshift({
          field: "date_creation",
          headerName: "Date de soumission",
          width: 200,
        });
      }
      // exportToExcel(rows, cols, titre);
      exportToExcelJS(
        rows,
        cols,
        `Banque de cv ${filter.objet_candidature?.libelle_type || ""}`,
        true,
      );
    }
    setOpenLoadingSimpleBackdrop(false);
  };

  const exportExperienceToExcel = (stat) => {
    setOpenLoadingSimpleBackdrop(true);
    if (stat > 0) {
      BanqueDeCvService.getExperience(filter)
        .then((result) => {
          if (result && result.data) {
            exportMultipleSheetsToExcelJS(
              result.data,
              `Details de l'expérience, diplome et formation des candidats ${
                filter.objet_candidature?.libelle_type || ""
              }`,
            );
          }
        })
        .finally(() => {
          setOpenLoadingSimpleBackdrop(false);
        });
    }
  };

  const handleSwitchCVinternExtern = (candidatExtern) => {
    setTableColumn(columns);
    if (!candidatExtern) {
      const cvIntFieldExcludeFiltre = [
        "direction_name",
        "service_name",
        "matricule",
        "poste",
        // "formation_fid",
      ];
      /* setTableColumn(
        columns.filter(
          (element) => !cvIntFieldExcludeFiltre.includes(element.field)
        )
      ); */
      return columns.filter(
        (element) => !cvIntFieldExcludeFiltre.includes(element.field),
      );
    } else {
      let cvIntFieldExcludeFiltre = [
        "objet_candidature",
        "date_envoie",
        "state",
        "adresse",
        "contact",
        "email",
        "direction_souhaiter",
      ];
      return columns.filter(
        (element) => !cvIntFieldExcludeFiltre.includes(element.field),
      );
    }
    setFilteredRows([]);
  };

  const columns = [
    {
      field: "matricule",
      headerName: "Matricule",
      width: 150,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography>{params.value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "full_name",
      headerName: "Nom et prenoms",
      width: 300,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography>{params.value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "adresse",
      headerName: "Adresse",
      width: 300,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography>{params.value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "contact",
      headerName: "Contact",
      width: 250,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography>{params.value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "email",
      headerName: "Adrresse email",
      width: 300,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography>{params.value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "objet_candidature",
      headerName: "Objet candidature",
      width: 300,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography>{params.value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "date_envoie",
      headerName: "Date d'envoie",
      width: 250,
      renderCell: (params) => (
        <Tooltip
          title={format(fromUnixTime(params.value), "dd MMMM yyyy à HH:mm:ss", {
            locale: fr,
          })}
        >
          <Typography>
            {format(fromUnixTime(params.value), "dd MMM yyyy à HH:mm:ss", {
              locale: fr,
            })}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "poste",
      headerName: "Fonction",
      width: 300,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography>{params.value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "direction_name",
      headerName: "Direction",
      width: 150,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography>{params.value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "service_name",
      headerName: "Service",
      width: 200,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography>{params.value}</Typography>
        </Tooltip>
      ),
    },
    {
      field: "diplome_formation",
      headerName: "Diplômes et Formations",
      width: 400,
      renderCell: (params) => {
        if (!params.value) return null;
        let items = String(params.value).substring(1).split("\n-") || [];
        return (
          <ul title={params.value}>
            {items.map((item, index) => (
              <li key={index}>{item.trim()}</li>
            ))}
          </ul>
        );
      },
    },
    {
      field: "experience_detail",
      headerName: "Experiences",
      width: 300,
      renderCell: (params) => {
        if (!params.value) return null;
        let items = String(params.value).substring(1).split("\n-") || [];
        return (
          <ul title={params.value}>
            {items.map((item, index) => (
              <li key={index}>{item.trim()}</li>
            ))}
          </ul>
        );
      },
    },
    {
      field: "formation_fid",
      headerName: "Formations",
      width: 300,
      renderCell: (params) => {
        if (!params.value) return null;
        let items = String(params.value).substring(1).split("\n-") || [];
        return (
          <ul title={params.value}>
            {items.map((item, index) => (
              <li key={index}>{item.trim()}</li>
            ))}
          </ul>
        );
      },
    },
    {
      field: "competence",
      headerName: "Domaines de compétence",
      width: 300,
      renderCell: (params) => {
        if (!params.value) return null;
        let items = String(params.value).substring(1).split("\n-") || [];
        return (
          <ul title={params.value}>
            {items.map((item, index) => (
              <li key={index}>{item.trim()}</li>
            ))}
          </ul>
        );
      },
    },
    {
      field: "sous_domaine_competence",
      headerName: "Sous domaine de compétence",
      width: 300,
      renderCell: (params) => {
        if (!params.value) return null;
        let items = String(params.value).substring(1).split("\n-") || [];
        return (
          <ul title={params.value}>
            {items.map((item, index) => (
              <li key={index}>{item.trim()}</li>
            ))}
          </ul>
        );
      },
    },
    {
      field: "type_stage",
      headerName: "Type de stage",
      width: 200,
    },
    {
      field: "disponibilite",
      headerName: "Disponibilité",
      width: 250,
    },
    {
      field: "direction_souhaiter",
      headerName: "Direction souhaitée",
      width: 300,
    },
    {
      field: "state",
      headerName: "Status dossier",
      width: 180,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography>{params.value}</Typography>
        </Tooltip>
      ),
    },
    /* {
      field: "dispose_un_cv",
      headerName: "Avoir CV",
      width: 150,
    }, */
    {
      field: "libelle_actions",
      headerName: "Actions",
      disableClickEventBulbing: true,
      renderCell: (params) => {
        return (
          <div>
            <Tooltip
              title={"Cliquer pour afficher le cv de " + params.row.full_name}
            >
              <span>
                <LoadingButton
                  size="small"
                  onClick={handleShowSelectedCV(params.row)}
                  color="primary"
                  variant="outlined"
                  loadingPosition="start"
                  loading={load.includes(params.row.us_id)}
                  // disabled={params.row.dispose_un_cv === "Non"}
                  startIcon={<VisibilityOutlinedIcon />}
                >
                  <Typography> Voir Cv</Typography>
                </LoadingButton>
              </span>
            </Tooltip>
            <Tooltip
              title={
                "Cliquer pour telecharger tous les fichiers envoyés par " +
                params.row.full_name
              }
            >
              <LoadingButton
                size="small"
                sx={{ ml: 1 }}
                onClick={() => handleDownloadZip(params.row)}
                color="secondary"
                variant="outlined"
                loadingPosition="start"
                loading={load.includes(params.row.us_id)}
              >
                <DownloadOutlined />
              </LoadingButton>
            </Tooltip>
          </div>
        );
      },
      width: 250,
    },
  ];

  const handleDowloadAllZip = (id_poste, file_name) => {
    setOpenLoadingSimpleBackdrop(true);
    //setLoadingDownload(true);
    try {
      BanqueDeCvService.downloadUploadedFilesByIdPoste(id_poste)
        .then((response) => {
          if (response.status !== 200) {
            showToast(TYPE_NOTIFICATION.ERROR, "Echec de telechargement");
            setOpenLoadingSimpleBackdrop(false);
            return;
          }
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${file_name || "Document de tous les candidats"} .zip`,
          );
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          setOpenLoadingSimpleBackdrop(false);
          //setLoadingDownload(false);
        });
    } catch (error) {
      setOpenLoadingSimpleBackdrop(false);
      showToast(TYPE_NOTIFICATION.ERROR, "Aucun fichier à télécharger");
    }
  };

  return (
    <React.Fragment>
      <Toast />
      <LoadingSimpleBackdrop
        openLoadingSimpleBackdrop={openLoadingSimpleBackdrop}
      />
      <Spacer y={2} />
      <Grid
        p={1}
        display={filter.isCVIntern ? "none" : "flex"}
        flexDirection={"row"}
        alignContent={"center"}
      >
        <label
          style={{ fontWeight: "bold", fontSize: "18px" }}
        >{` ${rows.reduce(
          (somme, row) => somme + (row.state === "complet" ? 1 : 0),
          0,
        )} dossier(s) complet(s) reçu(s)`}</label>
        <Tooltip title="Télécharger tous les dossiers envoyées">
          <LoadingButton
            sx={{ ml: 0.5 }}
            size="small"
            loading={loadingDownload}
            variant="outlined"
            startIcon={<DownloadOutlined />}
            onClick={() =>
              handleDowloadAllZip(
                filter.objet_candidature.id_type,
                filter.objet_candidature.libelle_type,
              )
            }
            disabled={!filter.objet_candidature}
          >
            Télécharger tous
          </LoadingButton>
        </Tooltip>
      </Grid>
      <div style={{ height: 500, width: "100%" }} className={classes.root}>
        {/*  <LinearProgress
          sx={{ display: loadExport ? "block" : "none" }}
        /> */}
        <DataGrid
          sx={{
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid rgba(224, 224, 224, 1)",
              alignContent: "center",
            },
            "& .MuiDataGrid-columnHeaders": {
              borderRight: "1px solid rgba(224, 224, 224, 1)",
            },
          }}
          getRowHeight={() => "auto"}
          rows={filteredRows}
          columns={tableColumns}
          getRowId={(row) => row.id_identite}
          pageSize={7}
          rowsPerPageOptions={[7]}
          disableSelectionOnClick
        />
      </div>
    </React.Fragment>
  );
}
